//                                                           //
//  Program: ResidentPayoutsReports.jsx                              //
//  Application: Report                                      //
//  Option: Property Reports Listing                         //
//  Developer: NP 		                                     //
//  Date: 2022-08-30                                         //
//                                                           //
/////////////////////////////////////////////////////////   ///

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import {
  Container,
  Tab,
  Modal,
  InputGroup,
  Form,
  Button,
} from "react-bootstrap";
import PayoutSidebar from "../common/PayoutSidebar";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import ReportService from "../../services/ReportService";
import Select from "react-select";
import UnitsService from "../../services/UnitsService";
import StripePayoutService from "../../services/StripePayoutService";
import SuccessLogo from "./../../assets/images/successImage.svg";
import Moment from "moment";
import MultiImageService from "./../../services/MultiImageService";
import { Link } from "react-router-dom";
import AllPropertyPayoutSidebar from "../common/AllPropertyPayoutSidebar";
import OutSidePropertySelectBox from "../outside-modules/OutSidePropertySelectBox";

class ResidentPayoutReportList extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.payoutDurationFromInputGroupRef = React.createRef();
    this.payoutDateInputGroupRef = React.createRef();
    this.payoutDurationToInputGroupRef = React.createRef();
    this.state = {
      payoutDurationFromPlacement: "bottom-start",
      payoutDatePlacement: "bottom-start",
      payoutDurationToPlacement: "bottom-start",
      errors: {},
      importModal: false,
      file_url: "",
      file_name: "",
      open: true,
      eventKey: "0",
      residentCount: "0",
      is_inactive: false,
      isSubmit: false,
      tableQueryString: "",
      customQueryString: "",
      showFilter: global.showFilter,
      is_by_paid: 1,
      module_search: "",
      importResponseModel: false,
      importTransferResponseModel: false,
      module_search_display: "",
      exportMesssage: "",
      exportFilePath: "",
      exportResult: "",
      alertType: "xlsx",
      exportReportType: "summary",
      is_search: 0,
      isSearch: global.isSearch,
      is_total: false,
      is_topup: false,
      confirmPay: false,
      markAsPaidModal: false,
      markAsPaidSlug: null,
      markAsPaidAction: null,
      isMarkingPaid: false,
      is_pay_out_modal: false,
      input: {},
      unitList: [],
      selectedUnitList: [],
      selectedStatusList: [],
      selectedPaymentStatusList: { value: "all", label: "All" },
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      filter_value: "",
      loading: false,
      showSpinner: false,
      total_record: 0,
      totalPayOutList: {},
      topupamout1: "",
      deleteRoleModal: false,
      isSend: false,
      pay_status_slug: "all",
      pay_status_lable: "All",
      property_slug: this.props.match.params.propertySlug,
      batch_slug: this.props.match.params.batchSlug,
      pathname: window.location.pathname,
      property_logo_url: sessionStorage.getItem("property_logo_url"),
      property_type: sessionStorage.getItem("property_type"),
      property_name: sessionStorage.getItem("property_name"),
      year_value: sessionStorage.getItem("year_value")
        ? sessionStorage.getItem("year_value")
        : "",
      records: [],
      config: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: false,
        show_filter: global.show_filter,
        show_pagination: false,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      configPay: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: false,
        show_filter: global.show_filter,
        show_pagination: false,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      outSidePropertySlug: "",
      newUnitList: [],
      statusList: [],
      paymentStatusList: [],
      payMethodList: [],
      extraButtons: [],
      columns: [
        {
          key: "report_id",
          text: "Report ID",
          className: "report_id hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.order_id;
          },
        },
        {
          key: "unit_name",
          text: "Unit",
          className: "unit_number hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.unit_name;
          },
        },
        {
          key: "resident_name",
          text: "Payable To",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.resident_name;
          },
        },
        {
          key: "payment_method",
          text: "Payment Method",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.payment_method;
          },
        },
        {
          key: "payment_date",
          text: "Payment Date",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.payout_date
              ? Moment(record.payout_date).format("MM/DD/YY")
              : "";
          },
        },
        {
          key: "payout_total_payouts",
          text: "Payment Amount",
          className:
            "payout_total_payouts hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.payout_total_payouts
              ? "$" +
                  global.onKeyPressEvent.numberWithCommasForDecimal(
                    parseFloat(record.payout_total_payouts)
                      .toFixed(2)
                      .replace(/\.00$/, "")
                  )
              : "$0";
          },
        },
        {
          key: "payment_ref_no",
          sortable: true,
          text: "Destination",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.payment_ref_no;
          },
        },
        {
          key: "payout_start_date",
          text: "Payout Duration",
          className: "payout_start_date hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.payout_start_date
              ? Moment(record.payout_start_date).format("MM/DD/YY") +
                  " - " +
                  Moment(record.payout_end_date).format("MM/DD/YY")
              : "";
          },
        },
        {
          key: "payout_status",
          text: "Status",
          width: "11%",
          className:
            "payout_total_payouts hand-cursor text-center td_clickable",
          cell: (record) => {
            const canAct =
              record.status_id === 1 &&
              global.userPermissions.checkPermission("payout-payments-update");
            if (canAct) {
              return (
                <div onClick={(e) => e.stopPropagation()}>
                  <Select
                    styles={{
                      option: (provided, state) => ({
                        ...provided,
                        color:
                          state.isSelected && state.isFocused
                            ? "white"
                            : state.isSelected
                            ? "black"
                            : state.isFocused && "white",
                        backgroundColor:
                          state.isSelected && state.isFocused
                            ? "black"
                            : state.isFocused && "black",
                      }),
                      menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                    menuPortalTarget={document.body}
                    isSearchable={false}
                    menuPlacement="auto"
                    className="multiselect"
                    value={{ value: 1, label: "Unpaid" }}
                    options={[
                      { value: 1, label: "Unpaid" },
                      { value: "manual_paid", label: "Manually Paid" },
                    ]}
                    onChange={(opt) => {
                      if (opt.value === "mark_paid") {
                        this.openMarkAsPaidModal(record.slug, "mark_paid");
                      } else if (opt.value === "manual_paid") {
                        this.openMarkAsPaidModal(record.slug, "manual_paid");
                      }
                    }}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 2,
                      colors: {
                        ...theme.colors,
                        primary: "#fff",
                        primary75: "#000",
                        primary50: "#000",
                        primary25: "#000",
                      },
                    })}
                  />
                </div>
              );
            }
            return record.payment_status;
          },
        },
      ],
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.getTotalBill = this.getTotalBill.bind(this);
    this.getData = this.getData.bind(this);
  }
  closeimportResponseModel() {
    this.setState({ importResponseModel: false });
    this.validator.hideMessages();
  }

  closeTransferResponseModel() {
    this.setState({ importTransferResponseModel: false });
    this.validator.hideMessages();
  }

  componentDidMount() {
    this.getData();
    if (this.props.match.params.propertySlug !== undefined) {
      this.getPayOutReports();
      this.gerDefaultInOutDate();
    }
  }

  getPropertySlug(property_slug) {
    this.setState({ property_slug: property_slug });
    setTimeout(() => {
      this.getPayOutReports();
      this.gerDefaultInOutDate();
    }, 200);
    this.setState({
      selectedUnitList: [],
      unit_slug: "",
      module_search: "",
      is_search: 0,
    });
  }

  SendSendTopUpAmount = async () => {
    let inputData = {
      topupamout: this.state.topupamout1,
    };
    let res = await StripePayoutService.SendTopUpAmount(inputData);
    this.setState({ isSend: true });
    if (global.successStatus.includes(res.status)) {
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      this.setState({ is_topup: 0 });
      this.setState({ importResponseModel: true });
      this.setState({ successMessage: res.message });
      this.setState({ topupamout1: "" });

      this.setState({ showSpinner: false, isSend: false });
    } else {
      if (res.data.result.errorDetail) {
        let errors = {};
        res.data.errorCode = "Validation Failed";
        res.data.result.errorDetail.forEach((item) => {
          errors[item.errorField] = item.errorMessage[0];
          res.data.errorMessage = "";
        });
        this.setState({ is_topup: 0 });
        this.setState({ showSpinner: false, isSend: false });
        this.setState({ errors: errors });
      }
    }
  };

  async clearFilter() {
    var date = new Date();
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.setState({ is_search: 0, is_by_paid: 1 });
    this.setState({
      payout_date: "",
      checkout_date_to: lastDay,
      payout_duration_start_date: "",
      payout_duration_end_date: "",
      unit_slug: "",
      selectedUnitList: [],
      selectedStatusList: [],
      selectedPaymentStatusList: [],
      selectedMethodList: [],
      status_slug: "",
      unit_lable: "",
      status_lable: "",
      method_lable: "",
      pay_status_slug: "all",
      pay_status_lable: "All",
    });
    this.setState({
      module_search: "",
      statusList: "",
      moduleList: "",
      paymentStatusList: "",
    });
    this.getPayOutReports();
  }

  async ExportData() {
    this.setState({ showSpinner: true, isSubmit: true, exportMesssage: "" });
    let payoutDate = this.state.payout_date
      ? Moment(this.state.payout_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationStartDate = this.state.payout_duration_start_date
      ? Moment(this.state.payout_duration_start_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationEndDate = this.state.payout_duration_end_date
      ? Moment(this.state.payout_duration_end_date).format("YYYY-MM-DD")
      : "";
    let unit_search = this.state.unit_slug
      ? this.state.unit_slug.map((slug) => `${slug}`).join(",")
      : "";
    let queryString =
      "&is_export=1" +
      "&file_type=" +
      this.state.alertType +
      "&report_type=" +
      this.state.exportReportType +
      "&payout_date=" +
      payoutDate +
      "&unit_slug=" +
      unit_search +
      "&payout_duration_start_date=" +
      payoutDurationStartDate +
      "&payout_duration_end_date=" +
      payoutDurationEndDate +
      "&payment_status=" + (this.state.pay_status_slug ? this.state.pay_status_slug : "") +
      "&payment_method=" +
      (this.state.method_slug ? this.state.method_slug : ""); 

    let res = await ReportService.getResidentPayOutReportsList((this.state.property_slug ? this.state.property_slug : ""), queryString);
    if (res.data.filePath) {
      this.getDownloadFile(res.data.filePath, res.data.fileName);
      // this.setState({ exportResult: data });
      this.setState({ exportFilePath: res.data.filePath });
    } else {
      this.setState({ exportMesssage: res.message });
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  async getDownloadFile(url, name) {
    let file_name = name.split(".")[0];
    var queryString = "path=" + url + "&display_file_name=" + file_name;
    this.setState({ showSpinner: true, loading: true });
    let inputData = {
      // path: url,
    };
    var resData = {};
    await MultiImageService.downloadFile(inputData, queryString);
    this.setState(resData);
    this.setState({
      showSpinner: false,
      loading: false,
    });
  }

  exportToggle = () => {
    if (this.state.isModel === 1) {
      this.setState({ exportMesssage: "" });
      this.setState({ isModel: 0 });
      this.setState({ showSpinner: false, isSubmit: false });
    } else {
      this.setState({ isModel: 1 });
    }
  };

  gerDefaultInOutDate() {
    this.setState({ payout_date: "" });
    this.setState({ payoutDurationEndDate: "" });
  }

  changeExport(evt) {
    let value = evt.target.value;
    this.setState({ alertType: value });
  }

  changeExportReportType(evt) {
    let value = evt.target.value;
    this.setState({ exportReportType: value });
  }

  async showPayoutReport(unitSlug) {
    this.setState({ showSpinner: true, loading: true });
    var listPay = [];
    var totalRecordsPay = 0;
    let payoutDetailsTitle;
    let data = {
      property_slug: this.state.property_slug,
    };
    let payoutDate = this.state.payout_date
      ? Moment(this.state.payout_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationDateStart = this.state.payout_duration_start_date
      ? Moment(this.state.payout_duration_start_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationDateTo = this.state.payout_duration_end_date
      ? Moment(this.state.payout_duration_end_date).format("YYYY-MM-DD")
      : "";
    let queryString =
      "unit_slug=" +
      unitSlug +
      "&payout_date=" +
      payoutDate +
      "&payout_duration_start_date=" +
      payoutDurationDateStart +
      "&payout_duration_end_date=" +
      payoutDurationDateTo;
    let res = await ReportService.showPayOutReport(data, queryString);
    if (global.successStatus.includes(res.status)) {
      listPay = res.data.data ? res.data.data : [];
      totalRecordsPay = res.data.data.length ? res.data.data.length : 0;
      payoutDetailsTitle = res.data.data.length
        ? res.data.data[0].aka_name + "-" + res.data.data[0].unit_number
        : "Pay Out Report";
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record_pay: totalRecordsPay,
      record_pay: listPay,
      payoutDetailsTitle: payoutDetailsTitle,
    });
    this.payoutDataModalToggle();
  }

  payoutDataModalToggle = () => {
    if (this.state.is_pay_out_modal === 1) {
      this.setState({ is_pay_out_modal: 0 });
    } else {
      this.setState({ is_pay_out_modal: 1 });
    }
  };

  getPayOutReports = async (queryString = "payment_status=all") => {
    this.setState({ showSpinner: true, loading: true });
    var list = [];
    var totalRecords = 0;
    let totalBill = 0;
    let totalBillTopUp = 0;
    let stripeActiveResidentCount = 0;
    if (this.state.batch_slug !== undefined) {
      queryString = "&batch_slug=" + this.state.batch_slug;
      this.setState({
        property_slug: "",
      });
    }
    let res = await ReportService.getResidentPayOutReportsList(
      this.state.property_slug ? this.state.property_slug : "",
      queryString
    );
    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data : [];
      totalRecords = Array.isArray(res.data) ? res.data.length : (res.data ? res.data.total : 0);
      totalBill = res.other_data ? res.other_data.final_total_payout_topup : 0;
      totalBillTopUp = res.other_data
        ? res.other_data.final_total_payout_topup
        : 0;
      stripeActiveResidentCount = res.other_data
        ? res.other_data.final_resident_stripe_count
        : 0;
      list = res.data ? res.data : [];
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record: totalRecords,
      records: list,
      list: list,
      totalBill: totalBill,
      totalBillTopUp: totalBillTopUp,
      residentCount: stripeActiveResidentCount,
    });
  };

  async getData() {
    this.setState({ showSpinner: true, loading: true });
    var Stripebalance = {};

    let res = await StripePayoutService.getstripebalance();

    if (global.successStatus.includes(res.status)) {
      Stripebalance = res.data.Stripe_balance ? res.data.Stripe_balance : {};
    }
    this.setState({
      showSpinner: false,
      loading: false,
      Stripebalance: Stripebalance,
    });
  }

  paymentpayout = async () => {
    this.setState({ isSend: true });
    let inputData = {
      result: this.state.list,
      other_data: this.state.totalBill,
    };
    let res = await StripePayoutService.payouttotalbill(inputData);
    if (global.successStatus.includes(res.status)) {
      //batchSlug = res.data ? res.data.batch_slug : "";
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      setTimeout(
        () => this.props.history.push("/stripe-transfer/resident"),
        global.redirect_time
      );
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    //this.totalbill();
    this.setState({ is_total: false });
    this.setState({ confirmPay: false });
    this.setState({
      importTransferResponseModel: true,
      successTranferMessage: "Payment Transfer Successfully",
      isSend: false,
    });
  };

  onChangetopup = (event) => {
    this.setState({ topupamout1: event.target.value });
  };

  /* to get unit data list */
  async getUnitData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var unitList = [];
    var unitListTotal = 0;
    let res = await UnitsService.getUnitsList(
      "is_dropdown=1&property_slug=" +
        (this.state.property_slug ? this.state.property_slug : ""),
      queryString ? "&" + queryString : ""
    );
    if (global.successStatus.includes(res.status)) {
      unitList = res.data ? res.data : [];
      unitListTotal = unitList ? unitList.length : 0;
    }
    const newUnitList =
      unitListTotal > 0
        ? unitList.map(({ slug, unit_name, tower, total_tower_count }) => ({
            value: slug,
            label: unit_name,
          }))
        : [];
    this.setState({
      unitList: unitList,
      unitListTotal: unitListTotal,
      newUnitList: newUnitList,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  // stripe

  async getTotalBill() {
    var totalBill = 0;
    let res = await StripePayoutService.gettotalpayment();

    if (global.successStatus.includes(res.status)) {
      totalBill = res.other_data.final_total_payout_topup
        ? res.other_data.final_total_payout_topup
        : 0;
    }

    this.setState({ totalBill: totalBill });
  }

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
    } else {
      this.setState({ showFilter: 1 });
    }
  };

  searchToggle = () => {
    if (this.state.isSearch === 1) {
      this.setState({ isSearch: 0 });
    } else {
      this.getUnitData();
      this.setState({ isSearch: 1 });
      const statusList = [
        { value: "success", label: "Success" },
        { value: "draft", label: "Draft" },
      ];
      const methodList = [
        { value: "Cash", label: "Cash" },
        { value: "Check", label: "Check" },
        { value: "online", label: "Online" },
      ];
      const paymentStatusList = [
        { value: "all", label: "All" },
        { value: "unpaid", label: "Unpaid" },
        { value: "paid", label: "Paid" },
        { value: "draft", label: "Draft" },
      ];
      this.setState({
        statusList: statusList,
        payMethodList: methodList,
        paymentStatusList: paymentStatusList,
      });
    }
  };

  totalbill = () => {
    if (this.state.is_total === true) {
      this.setState({ is_total: false });
    } else {
      this.setState({ is_total: true });
    }
  };

  totalTopup = () => {
    let topBalanceRequired = 0;
    if (this.state.totalBillTopUp > this.state.Stripebalance) {
      if (
        this.state.totalBillTopUp !== undefined &&
        this.state.Stripebalance !== undefined
      ) {
        topBalanceRequired =
          parseFloat(this.state.totalBillTopUp) -
          parseFloat(this.state.Stripebalance);
      }
    }
    this.setState({ top_up_amount: topBalanceRequired });
    if (this.state.is_topup === true) {
      this.setState({ is_topup: false });
    } else {
      this.setState({ is_topup: true });
    }
  };

  confirmPayClose = () => {
    if (this.state.confirmPay === true) {
      this.setState({ confirmPay: false });
    } else {
      this.setState({ confirmPay: true });
      this.setState({ is_total: false });
    }
  };

  handleChangeUnitList(value) {
    let unit_slug = [];
    let unit_lable = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
        unit_lable.push(item.label);
      });
    }
    // const unit_slug_value = value !== null ? value.value : [];
    // const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedUnitList: value,
      unit_slug: unit_slug,
      unit_lable: unit_lable,
    });
    this.setState({ confirm_back: 1 });
  }

  handleChangeStatusList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedStatusList: value,
      status_slug: unit_slug_value,
      status_lable: selected_unit_number,
    });
  }

  handleChangePaymentStatusList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({ is_by_paid: 0 });
    this.setState({
      selectedPaymentStatusList: value,
      pay_status_slug: unit_slug_value,
      pay_status_lable: selected_unit_number,
    });
  }

  handleChangeMethodList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedMethodList: value,
      method_slug: unit_slug_value,
      method_lable: selected_unit_number,
    });
  }

  customValidate() {
    let isValid = true;
    return isValid;
  }

  getResponsivePlacement = (ref) => {
    if (!ref.current) return "bottom-start";

    const rect = ref.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const CALENDAR_HEIGHT_ESTIMATE = 330;
    const CALENDAR_WIDTH_ESTIMATE = 300;

    if (spaceBelow >= CALENDAR_HEIGHT_ESTIMATE || window.innerWidth <= 767) {
      return "bottom-start";
    }

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= CALENDAR_WIDTH_ESTIMATE) return "right-start";
    if (spaceLeft >= CALENDAR_WIDTH_ESTIMATE) return "left-start";
    return spaceRight >= spaceLeft ? "right-start" : "left-start";
  };

  checkPayoutDurationFromPlacement = () => {
    this.setState({
      payoutDurationFromPlacement: this.getResponsivePlacement(this.payoutDurationFromInputGroupRef),
    });
  };

  checkPayoutDatePlacement = () => {
    this.setState({
      payoutDatePlacement: this.getResponsivePlacement(this.payoutDateInputGroupRef),
    });
  };

  checkPayoutDurationToPlacement = () => {
    this.setState({
      payoutDurationToPlacement: this.getResponsivePlacement(this.payoutDurationToInputGroupRef),
    });
  };

  changeHandler = async (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    await this.setState({ [event.target.name]: value, input: input });
    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };

  async filterData() {
    let payoutDate = this.state.payout_date
      ? Moment(this.state.payout_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationStartDate = this.state.payout_duration_start_date
      ? Moment(this.state.payout_duration_start_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationEndDate = this.state.payout_duration_end_date
      ? Moment(this.state.payout_duration_end_date).format("YYYY-MM-DD")
      : "";
    let unit_search = this.state.unit_slug
      ? this.state.unit_slug.map((slug) => `${slug}`).join(",")
      : "";
    let queryString =
      "unit_slug=" +
      unit_search +
      "&status_slug=" +
      (this.state.status_slug ? this.state.status_slug : "") +
      "&payment_method=" +
      (this.state.method_slug ? this.state.method_slug : "") +
      "&payout_date=" +
      payoutDate +
      "&payout_duration_start_date=" +
      payoutDurationStartDate +
      "&payout_duration_end_date=" +
      payoutDurationEndDate +
      "&payment_status=" +
      (this.state.pay_status_slug ? this.state.pay_status_slug : "") +
      "&is_search=1";
    let moduleSearchString = "";
    let searchDisplay = "";
    let comma = ",";
    moduleSearchString = this.state.unit_slug
      ? moduleSearchString
        ? moduleSearchString + " ," + " Unit - " + this.state.unit_slug
        : " Unit - " + this.state.unit_slug
      : moduleSearchString;
    if (this.state.unit_lable) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Unit: " +
        this.state.unit_lable;
    }
    if (this.state.status_lable) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Status: " +
        this.state.status_lable;
    }
    if (this.state.method_lable) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        "Payment Method: " +
        this.state.method_lable;
    }
    if (this.state.payout_date) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Payout Date: " +
        Moment(payoutDate).format("MM/DD/YY");
    }
    if (this.state.payout_duration_start_date) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Payout Duration Start Date: " +
        Moment(payoutDurationStartDate).format("MM/DD/YY");
    }
    if (this.state.payout_duration_end_date) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        "Payout Duration To Date: " +
        Moment(payoutDurationEndDate).format("MM/DD/YY");
    }
    if (this.state.pay_status_lable.length > 0) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        "Status: " +
        this.state.pay_status_lable;
    }
    if (
      this.state.payout_date ||
      this.state.unit_slug ||
      this.state.payout_duration_start_date ||
      this.state.payout_duration_end_date ||
      this.state.pay_status_lable
    ) {
      this.setState({ customQueryString: queryString });
      this.searchToggle();
      this.setState({ is_search: 1, is_by_paid: 0 });
      this.setState({ module_search: moduleSearchString });
      this.setState({ module_search_display: searchDisplay.split(",") });
      this.getPayOutReports(queryString);
    }
  }

  /* table events */
  tableChangeHandler = (data) => {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "page_size") {
            newKey = "per_page";
          } else if (key === "sort_order") {
            data[key] = "asc";
          }
          return (
            encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key])
          );
        }
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      queryString += "&" + this.state.customQueryString;
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getPayOutReports(queryString),
          global.filter_time
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getPayOutReports(queryString);
    }
  };

  rowClickedHandlerPay = (event, data, rowIndex) => {
    if (data.unit_slug) {
      this.showPayoutReport(data.unit_slug);
    }
  };

  rowClickedHandler = (event, data, rowIndex) => {
    if (data.slug) {
      // status_id 1 or 2 = finalized/sent payout — route to read-only view (ResidentPayoutsReportsEdit); otherwise route to editable update form (ResidentPayoutsReportsUpdate)
      if (data.status_id === 1 || data.status_id === 2 || data.status_id === 5) {
        this.props.history.push(
          this.props.match.params.propertySlug !== undefined
            ? "/properties/view/" +
                data.property_slug +
                "/view-payout-resident/" +
                data.slug
            : "/view-payout-resident/" + data.property_slug + "/" + data.slug
        );
      } else {
        this.props.history.push(
          this.props.match.params.propertySlug !== undefined
            ? "/properties/view/" +
                data.property_slug +
                "/edit-payout-resident/" +
                data.slug
            : this.state.property_slug
            ? "/edit-payout-resident/" +
              this.state.property_slug +
              "/" +
              data.slug
            : "/edit-payout-resident/" + data.property_slug + "/" + data.slug
        );
      }
    }
  };

  openMarkAsPaidModal = (slug, action) => {
    this.setState({ markAsPaidModal: true, markAsPaidSlug: slug, markAsPaidAction: action });
  };

  confirmMarkAsPaid = async () => {
    this.setState({ isMarkingPaid: true });
    const paymentStatus = this.state.markAsPaidAction === "manual_paid" ? 5 : 2;
    let res = await ReportService.updateResidentPayoutStatus({
      slug: this.state.markAsPaidSlug,
      payment_status: paymentStatus,
    });
    if (global.successStatus.includes(res.status)) {
      this.setState({
        markAsPaidModal: false,
        markAsPaidSlug: null,
        markAsPaidAction: null,
        isMarkingPaid: false,
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message
          ? res.message
          : paymentStatus === 5
          ? "Payout marked as Manually Paid."
          : "Payout marked as Paid.",
      });
      this.getPayOutReports(this.state.customQueryString);
    } else {
      this.setState({
        markAsPaidModal: false,
        markAsPaidSlug: null,
        markAsPaidAction: null,
        isMarkingPaid: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
  };

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };
    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    {this.props.match.params.propertySlug !== undefined ? (
                      <PayoutSidebar property_slug={this.state.property_slug} />
                    ) : (
                      <AllPropertyPayoutSidebar
                        property_slug={this.state.property_slug}
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0 payable_head">
                      <h3>Resident Payouts</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        <button
                          className="btn-success-outline-small button-width ml-3"
                          onClick={this.searchToggle}
                        >
                          Search
                        </button>
                        {global.userPermissions.checkPermission(
                          "payout-payments-export"
                        ) ? (
                          <button
                            className="btn-success-outline-small mr-0"
                            onClick={this.exportToggle}
                          >
                            Export
                          </button>
                        ) : (
                          ""
                        )}
                        {global.userPermissions.checkPermission(
                          "payout-payments-add"
                        ) &&
                          this.state.property_slug && (
                            <Link
                              to={
                                this.props.match.params.propertySlug !==
                                undefined
                                  ? "/properties/view/" +
                                    this.state.property_slug +
                                    "/create-payout-resident"
                                  : "/create-payout-resident/" +
                                    this.state.property_slug
                              }
                            >
                              <button className="btn-success-outline-small button-width ml-3">
                                Create Payout
                              </button>
                            </Link>
                          )}
                        {global.userPermissions.checkPermission(
                          "payout-payments-add"
                        ) &&
                          this.state.property_slug && (
                            <button
                              disabled={this.state.totalBill == 0}
                              disableElevation
                              className="btn-success-outline-small ml-3 button-width-cust btn-disable-theme-payout"
                              onClick={this.totalbill}
                            >
                              Send Transfer
                            </button>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-lg-l-0 pd-lg-r-15 pd-xs-r-0">
                    {this.props.match.params.propertySlug === undefined ? (
                      <>
                        <div className="row pd-lg-l-15 pd-xs-l-0">
                          <div className="col-xxl-2 col-sm-3 pd-lg-r-0 pd-xs-r-15 pd-lg-l-45 pd-xs-l-15">
                            <OutSidePropertySelectBox
                              propertySlug={this.getPropertySlug.bind(this)}
                              outSidePropertySlug={this.state.outSidePropertySlug}
                            />
                          </div>
                          <div className="col-xxl-10 col-md-9 col-sm-8 pd-r-15 pd-l-15">
                            {this.state.is_search === 1 ? (
                              this.state.module_search_display ? (
                                <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                                  <div className="custm-filter">
                                    <div>
                                      {" "}
                                      <label className="form-label text-left pd-b-2 mb-0">
                                        Search Applied On
                                      </label>
                                    </div>
                                    <div className="filter_bg_cust">
                                      {this.state.module_search_display.map(
                                        (item, i) => {
                                          return <span key={i}>{item}</span>;
                                        }
                                      )}
                                      <button
                                        onClick={this.clearFilter}
                                        className="btn-fliter-clear"
                                      >
                                        Clear
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )
                            ) : this.state.batch_slug ? (
                              ""
                            ) : (
                              <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                                <div className="custm-filter">
                                  <div>
                                    {" "}
                                    <label className="form-label text-left pd-b-2 mb-0">
                                      Search Applied On
                                    </label>
                                  </div>
                                  <div className="filter_bg_cust">
                                    <span>
                                      Status -{this.state.pay_status_lable}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="col-xxl-12 pd-r-15 pd-l-15">
                        {this.state.is_search === 1 ? (
                          this.state.module_search_display ? (
                            <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                              <div className="custm-filter">
                                <div>
                                  {" "}
                                  <label className="form-label text-left pd-b-2 mb-0">
                                    Search Applied On
                                  </label>
                                </div>
                                <div className="filter_bg_cust">
                                  {this.state.module_search_display.map(
                                    (item, i) => {
                                      return <span key={i}>{item}</span>;
                                    }
                                  )}
                                  <button
                                    onClick={this.clearFilter}
                                    className="btn-fliter-clear"
                                  >
                                    Clear
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : this.state.batch_slug ? (
                          ""
                        ) : (
                          <div className="col-xxl-12 col-sm-12 pd-xs-r-0 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel mg-b-20">
                            <div className="custm-filter">
                              <div>
                                {" "}
                                <label className="form-label text-left pd-b-2 mb-0">
                                  Search Applied On
                                </label>
                              </div>
                              <div className="filter_bg_cust">
                                <span>
                                  Status -{this.state.pay_status_lable}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {this.state.batch_slug === undefined ? (
                      <div className="col-xxl-12 col-sm-12 pd-lg-r-15 pd-xs-r-15 text-right">
                        <div className="paid_amt_cnt">
                          <ul>
                            <li>
                              <p className="total_patout_text m-0">
                                Unpaid Amount:{" "}
                                <span>
                                  $
                                  {this.state.totalBill
                                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                                        parseFloat(this.state.totalBill)
                                          .toFixed(2)
                                          .replace(/\.00$/, "")
                                      )
                                    : 0}
                                </span>
                              </p>
                            </li>
                            <li>
                              <p className="total_patout_text m-0">
                                Payout Count:{" "}
                                <span>{this.state.residentCount ?? 0}</span>
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="scrolling-carousel pd-l-15 scroll-slide">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="all"
                        onSelect={(e) => this.getActiveClass(e)}
                        eventKey={this.state.activeClass}
                        className="pd-r-60"
                      >
                        <Tab.Content className="m-0">
                          <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                            <div className="mg-t-18 brandList pd-l-15 pd-r-15 Report_table earning-report-tbl ">
                              <div className=" pd-lg-l-0 pd-xs-l-0">
                                <div className="scroll-report-table">
                                  <ReactDatatable
                                    className="table no-wrap mg-b-30 pd-b-2  brandtable border earning_reports resident-payout-table "
                                    config={
                                      this.state.total_record > global.page_size
                                        ? this.state.config
                                        : this.state.config
                                    }
                                    records={this.state.records}
                                    columns={this.state.columns}
                                    extraButtons={this.state.extraButtons}
                                    dynamic={true}
                                    total_record={this.state.total_record}
                                    onChange={this.tableChangeHandler}
                                    onRowClicked={this.rowClickedHandler}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* Module search popup modal */}
        <Modal
          show={this.state.isSearch}
          className="modal-large searchModalbox"
          centered
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.searchToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Search in Payout Payments</h3>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Unit</label>
                  <div className="col-md-12 p-0">
                    <Select
                      isMulti
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      classNamePrefix={"my-custom-react-select"}
                      menuPlacement="auto"
                      value={this.state.selectedUnitList}
                      options={this.state.newUnitList}
                      onChange={(value) => this.handleChangeUnitList(value)}
                      defaultValue={this.state.selectedUnitList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
                <InputGroup className="mt-3">
                  <label>Payment Method</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      classNamePrefix={"my-custom-react-select"}
                      menuPlacement="auto"
                      value={this.state.selectedMethodList}
                      options={this.state.payMethodList}
                      onChange={(value) => this.handleChangeMethodList(value)}
                      defaultValue={this.state.selectedMethodList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
                <InputGroup className="mt-3" ref={this.payoutDurationFromInputGroupRef}>
                  <label>Payout Duration From Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="payout_duration_start_date"
                    selected={this.state.payout_duration_start_date}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.changeHandler({
                        target: {
                          type: "date",
                          name: "payout_duration_start_date",
                          value: data,
                        },
                      })
                    }
                    popperPlacement={this.state.payoutDurationFromPlacement}
                    onCalendarOpen={this.checkPayoutDurationFromPlacement}
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Status</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      classNamePrefix={"my-custom-react-select"}
                      menuPlacement="auto"
                      value={this.state.selectedPaymentStatusList}
                      options={this.state.paymentStatusList}
                      onChange={(value) =>
                        this.handleChangePaymentStatusList(value)
                      }
                      defaultValue={this.state.selectedPaymentStatusList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
                <InputGroup className="mt-3" ref={this.payoutDateInputGroupRef}>
                  <label>Payment Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="payout_date"
                    selected={this.state.payout_date}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.changeHandler({
                        target: {
                          type: "date",
                          name: "payout_date",
                          value: data,
                        },
                      })
                    }
                    popperPlacement={this.state.payoutDatePlacement}
                    onCalendarOpen={this.checkPayoutDatePlacement}
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                </InputGroup>
                <InputGroup className="mt-3" ref={this.payoutDurationToInputGroupRef}>
                  <label>Payout Duration To Date</label>
                  <div className="col-md-12 p-0">
                    <DatePicker
                      className="form-control max_width_100"
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      disabledKeyboardNavigation
                      strictParsing
                      autoComplete="off"
                      yearDropdownItemNumber={global.yearDropdownItemNumber}
                      name="payout_duration_end_date"
                      selected={this.state.payout_duration_end_date}
                      dateFormat="MM/dd/yy"
                      onChange={(data) =>
                        this.changeHandler({
                          target: {
                            type: "date",
                            name: "payout_duration_end_date",
                            value: data,
                          },
                        })
                      }
                      popperPlacement={this.state.payoutDurationToPlacement}
                      onCalendarOpen={this.checkPayoutDurationToPlacement}
                      popperModifiers={{
                        preventOverflow: {
                          enabled: true,
                          escapeWithReference: false,
                        },
                      }}
                    />
                  </div>
                </InputGroup>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.searchToggle()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.filterData()}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Search"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Module total bill popup modal */}
        <Modal show={this.state.is_total} className=" searchModalbox1" centered>
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span className="welcomeClose" onClick={() => this.totalbill()}>
              {global.closee}
            </span>
            <h3 className="text-center">Send Transfer</h3>

            <div className="payout_modal_box">
              <p>
                Available Stripe Balance:{" "}
                <span>
                  $
                  {this.state.Stripebalance
                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                        parseFloat(this.state.Stripebalance)
                          .toFixed(2)
                          .replace(/\.00$/, "")
                      )
                    : 0}
                </span>
              </p>
              <hr className="hr_cust" />
              <p>
                Payable Amount:{" "}
                <span>
                  $
                  {this.state.totalBill
                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                        parseFloat(this.state.totalBill)
                          .toFixed(2)
                          .replace(/\.00$/, "")
                      )
                    : 0}
                </span>
              </p>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.confirmPayClose()}
              >
                Confirm
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.confirmPay}
          className=" searchModalbox1 confirm_modal_box"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span
              className="welcomeClose"
              onClick={() => this.confirmPayClose()}
            >
              {global.closee}
            </span>

            <h3 className="text-center mt-3">
              Are you sure you want to transfer payable amount?
            </h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <div className="d-flex justify-content-center mt-3 row">
                  <button
                    type="button"
                    className="m-0 btn btn btn-success btn-block"
                    onClick={() => this.paymentpayout()}
                  >
                    {this.state.isSend ? global.loader : "Yes"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0  btn btn-outline-light btn-block ml-3"
                    onClick={() => this.confirmPayClose()}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal for Top-ups */}
        <Modal show={this.state.is_topup} className=" searchModalbox1" centered>
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span className="welcomeClose" onClick={() => this.totalTopup()}>
              {global.closee}
            </span>
            <h3 className="text-center">Add funds to your Stripe balance</h3>
            <div className="payout_modal_box">
              <p>
                Available stripe balance:{" "}
                <span>
                  $
                  {this.state.Stripebalance
                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                        parseFloat(this.state.Stripebalance)
                          .toFixed(2)
                          .replace(/\.00$/, "")
                      )
                    : 0}
                </span>
              </p>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <Form.Control
                type="text"
                name="topupamout"
                value={this.state.topupamout1}
                id="topupamout"
                onChange={(e) => this.onChangetopup(e)}
              />
              <Button
                type="button"
                className=" m-0 btn-success btn-block"
                onClick={() => this.SendSendTopUpAmount()}
              >
                {this.state.isSend ? global.loader : "Add to stripe balance "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* show response model  */}
        <Modal
          show={this.state.importResponseModel}
          className="modal-xs recordDetailmodalbox"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeimportResponseModel()}
            >
              {global.closee}
            </span>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <div className="d-flex justify-content-between mt-0 row">
                  <div className="msg">
                    <img src={SuccessLogo} alt="filterIcon" />
                    <p>{this.state.successMessage}</p>{" "}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* show success of Transfer payout  */}
        <Modal
          show={this.state.importTransferResponseModel}
          className="modal-xs recordDetailmodalbox"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeTransferResponseModel()}
            >
              {global.closee}
            </span>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <div className="d-flex justify-content-between mt-0 row">
                  <div className="msg">
                    <img src={SuccessLogo} alt="filterIcon" />
                    <p>{this.state.successTranferMessage}</p>{" "}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* Mark as Paid confirmation modal */}
        <Modal
          show={this.state.markAsPaidModal}
          className="searchModalbox1 confirm_modal_box"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span
              className="welcomeClose"
              onClick={() =>
                this.setState({ markAsPaidModal: false, markAsPaidSlug: null, markAsPaidAction: null })
              }
            >
              {global.closee}
            </span>
            <h3 className="text-center mt-3">
              {this.state.markAsPaidAction === "manual_paid"
                ? "Are you sure you want to mark this payout as Manually Paid?"
                : "Are you sure you want to mark this payout as Paid?"}
            </h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <div className="d-flex justify-content-center mt-3 row">
                  <button
                    type="button"
                    className="m-0 btn btn-success btn-block"
                    onClick={() => this.confirmMarkAsPaid()}
                  >
                    {this.state.isMarkingPaid ? global.loader : "Yes"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0 btn btn-outline-light btn-block ml-3"
                    onClick={() =>
                      this.setState({
                        markAsPaidModal: false,
                        markAsPaidSlug: null,
                        markAsPaidAction: null,
                      })
                    }
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.isModel} className="modal-xs" centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.exportToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Export</h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <InputGroup className="mt-0">
                  <label>Select Export Report Type : </label>
                  <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExportReportType(e)}
                        name="export_report_type"
                        value="summary"
                        checked={this.state.exportReportType === "summary"}
                        type={"radio"}
                        id="report_type_summary"
                        label={"Summary"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExportReportType(e)}
                        name="export_report_type"
                        value="detailed"
                        checked={this.state.exportReportType === "detailed"}
                        type={"radio"}
                        id="report_type_detailed"
                        label={"Detailed"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                  </div>
                </InputGroup>
                <InputGroup className="mt-3">
                  <label>Select Export File Type : </label>
                  <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="xlsx"
                        checked={this.state.alertType === "xlsx" ? true : false}
                        type={"radio"}
                        id="xlsx"
                        label={"XLSX"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="csv"
                        checked={this.state.alertType === "csv" ? true : false}
                        type={"radio"}
                        id="csv"
                        label={"CSV"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                    {/* <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="pdf"
                        checked={this.state.alertType === "pdf" ? true : false}
                        type={"radio"}
                        id="pdf"
                        label={"PDF"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div> */}
                  </div>
                </InputGroup>


                {this.state.exportMesssage !== "" && (
                  <div className="mt-2 text-danger">
                    {this.state.exportMesssage}
                  </div>
                )}

                <div className="d-flex justify-content-center mt-3">
                  <button
                    type="button"
                    className="mx-auto- mg-r-30 btn btn btn-success btn-block"
                    onClick={() => this.ExportData()}
                    disabled={this.state.isSubmit ? true : false}
                  >
                    {this.state.isSubmit ? global.loader : "Export"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0  btn btn-outline-light btn-block"
                    onClick={() => this.exportToggle()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default ResidentPayoutReportList;
